AddPageSwapTrigger(function() {
    function setupBackLink() {
        $(this).click(navigateToPrevious);
        $(this).attr('data-no-swup', '1');
    }

    $('.teruglink').each(setupBackLink);
    $('div.backlinkmobile a').each(setupBackLink);
    $('a.backlinkmobile').each(setupBackLink);

})


$(document).ready(function() {
    $(document).on('swup:popState', function () {
        isBackButton = true;
    });
	$(document).on('swup:popState', function () {
		$('.modal').remove();
		$('.modal-backdrop').remove();
		$('body').removeClass( "modal-open" );
    });
    $(document).on('swup:pageView', function () {
        if(isBackButton){ // backbutton or history.go(-1) fired.
            isBackButton = false;
            times -= 2;
        }
        else {
        }

        if(times > 1) {
            $('.teruglink').each(function () {
                if ($(this).text().trim().substring(0, sk_i18n.backlink.length) == sk_i18n.backlink) {
                    $(this).html('<span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> ' + sk_i18n.backlink);
                }
            });
        }
    });
});